import { useIntl } from "react-intl";

import {
    StandardPriceCard,
    ProductPriceCardProps
} from "./pricing-calculator-plan-card.tsx";

export const RovoDevStandardPriceCard = (props: ProductPriceCardProps) => {
    const intl = useIntl();
    return (
        <StandardPriceCard
            {...props}
            isSingleCard
            monthlyPerUserLabel={intl.formatMessage({
                id: "RovoDevStandardPriceCard.monthlyPerUserLabel",
                defaultMessage: "per developer / month"
            })}
        />
    );
};
